export default {
    colors: {
        primary: '#4BAAF7',
        secondary: '#ED91BB'
    },
    overrideFunction: ({ colors }) => ({
        h1BorderColor: colors.primary,
        h2BorderColor: colors.primary,
        colorLink: colors.secondary,
        subNavBg: colors.secondary,
        subNavMobileBackgroundColor: colors.secondary,
        partnerOfferMain: colors.primary,
        partnerCardMainDiscountColor: colors.primary,
        howItWorkBlockBoldColor: colors.primary,
        faqLinkTextColor: colors.black,
        hrBackgroundColor: colors.primary,

        buttonMainBg: colors.secondary,
        buttonMainText: colors.white,
        buttonMainBorder: colors.secondary,
        buttonMainHoverBg: colors.secondary,
        buttonMainHoverText: colors.white,
        buttonMainHoverBorder: colors.secondary
    })
};



// WEBPACK FOOTER //
// ./src/style/applicationSpecific/macadamTheme.js